var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAdj = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464.2 492",
    style: {
      enableBackground: "new 0 0 464.2 492"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.adj0{fill:#00BED5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "adj0",
    d: "M261.1,97.8c3.7,0.8,7.4,1.8,11,2.9c22.1,6.6,43,17.6,60.8,32.2c16.8,13.8,30.9,30.7,41.4,49.8 c10.6,19.2,17.5,40.5,20.3,62.2C407,337,342.2,423.2,250,437.4c-31.5,4.9-64.1,0.9-93.5-11.5c-28.6-12.1-53.7-32-72.1-57.1 c-8.4-11.5-15.4-24-20.8-37.3c-15.7-38.9-17-83-2.8-122.5c7.3-20.3,18.1-39.3,32.2-55.6c8.9-10.4,19.1-19.7,30.3-27.6 c10.3-7.3,21.6-13.6,33.6-18.7c9.4-3.9,19.3-7.1,29.6-9.5C210.9,92,236.7,92.2,261.1,97.8z M373.7,266.5 c-0.1-83.2-67.3-150.4-150.3-150.5c-82.8,0-150.2,67.6-150.1,150.7c0.1,83.1,67.5,150.6,150.3,150.5 C306.7,417.1,373.8,349.6,373.7,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adj0",
    d: "M304.7,348.5C317.8,336.2,324,330,324,330l-75-168.9h-28.2l-33.8,78.3c0,0-53-29.2-72.9-9 c-20,20.1,5.8,66.8,30.2,95.5c6,0,26.3,0,26.3,0l11.7-25.5l-11.9-25.7l-13.4,30.1c0,0-38.2-47.7-26.4-58.3S240.9,293.4,304.7,348.5 z M233.9,184.6c0,0,38.6,81.7,54,121.1c-23.5-17.9-82.5-55.9-82.5-55.9L233.9,184.6z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 3744 1656)",
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 12
    }
  }, "8851"));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdj, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/adj.446257f9.svg";
export { ForwardRef as ReactComponent };